import type { FC } from 'react';
import NumberedBlockList from './NumberedBlockList';
import type { Block } from 'interfaces/EnergyAudit.interface';

interface RenderBlocksProps {
  blocks?: Block[];
  emptyMessage?: string;
  showTitle?: boolean;
  title?: string;
}

const RenderBlocks: FC<RenderBlocksProps> = ({
  blocks,
  emptyMessage = 'No data available.',
  showTitle,
  title,
}) => {
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return <div>{emptyMessage}</div>;
  }

  const hasSubpoints = blocks.some(
    (block: Block) =>
      block.content &&
      Array.isArray(block.content.subpoints) &&
      block.content.subpoints.length > 0
  );

  if (
    hasSubpoints ||
    blocks.some(
      (block: Block) =>
        Array.isArray(block.content.subpoints) &&
        block.content.subpoints.length > 0
    )
  ) {
    return (
      <>
        {showTitle && title && (
          <div className="font-bold text-base mb-2">{title}</div>
        )}
        <ul className="list-disc pl-4 mb-4 text-gray-50">
          {blocks.map((block: any, idx: number) => (
            <li key={idx} className="mb-2">
              {block.content.name !== '<answer>' && (
                <>
                  <span className="font-bold">{block.content.name}</span>
                  {block.content.text ? ': ' : ': '}
                </>
              )}
              <span className="font-normal">
                {block.content.text || block.content.answer}
              </span>
              {block.content.subpoints &&
                Array.isArray(block.content.subpoints) &&
                block.content.subpoints.length > 0 && (
                  <ul className="list-disc pl-6 mt-1">
                    {block.content.subpoints.map((sp: any, i: number) => (
                      <li key={i}>
                        <span className="font-normal">
                          {typeof sp === 'string' ? sp : sp?.answer || ''}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
            </li>
          ))}
        </ul>
      </>
    );
  }

  if (
    blocks.every(
      (block: any) =>
        typeof block.type === 'string' &&
        block.type.toLowerCase().includes('bullet')
    )
  ) {
    return (
      <ul className="list-disc pl-4 text-gray-50">
        {blocks.map((block: any, idx: number) => (
          <li key={idx} className="mb-2">
            {block.content.name !== '<answer>' && (
              <>
                <span className="font-bold">{block.content.name}</span>
                {': '}
              </>
            )}
            <span className="font-normal">{block.content.answer}</span>
          </li>
        ))}
      </ul>
    );
  }
  if (
    blocks.every(
      (block: any) =>
        typeof block.type === 'string' &&
        block.type.toLowerCase().includes('numbered')
    )
  ) {
    return <NumberedBlockList blocks={blocks} />;
  }
  return <div>{emptyMessage}</div>;
};

export default RenderBlocks;
